import { backendAPI } from "../../helper/apis"

export function updateInfractionComment(infractionId, { comment }) {
  return backendAPI.put(`/v2/infractions/${infractionId}`, { comment })
}
